export const PAYMENT_REQUESTS_QUERY_KEY = "paymentRequests"
export const CUSTOMERS_QUERY_KEY = "customers"
export const USERS_QUERY_KEY = "users"
export const INVITES_QUERY_KEY = "invites"
export const SERVICES_QUERY_KEY = "services"
